import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, forwardRef, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { InputHelperTextComponent } from 'app/shared/components/input-helper-text/input-helper-text.component';
import { Subject } from 'rxjs/internal/Subject';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-checkbox-form-field',
  standalone: true,
  imports: [CommonModule, TranslateModule, ReactiveFormsModule, InputHelperTextComponent],
  templateUrl: './checkbox-form-field.component.html',
  styleUrl: './checkbox-form-field.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CheckboxFormFieldComponent),
      multi: true,
    }
  ],
})
export class CheckboxFormFieldComponent implements ControlValueAccessor, OnInit, OnDestroy {
  @Input() label: string = '';
  @Input() viewMode!: boolean;
  @Input() helpText!: string;
  @Input() customClass!: string;
  @Output() onChangeCheckboxEvent = new EventEmitter<boolean>();


  formControl: FormControl = new FormControl<string>('');
  errorText: string = '';

  private unsubscribe$ = new Subject<void>();

  constructor(private changeDetectorRef: ChangeDetectorRef) {}

  onTouch: () => void = () => {};
  onChange: (value: any) => void = () => {};

  registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouch = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    isDisabled ? this.formControl.disable() : this.formControl.enable();
  }

  writeValue(value: boolean): void {
    this.formControl.setValue(value);
    this.changeDetectorRef.markForCheck();
  }

  ngOnInit(): void {
    this.formControl.valueChanges
      .pipe(
        takeUntil(this.unsubscribe$)
      )
      .subscribe((value) => {
        this.onChange(value);
      });
  }

  onChangeCheckbox(event: any) {
    this.onChangeCheckboxEvent.emit(event.target.checked);
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

}
